// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'eye-solid';

export const Component = () => (
  <path d='M17.002 6.005C15.422 5.335 13.84 5 12.26 5s-3.16.335-4.741 1.005c-1.58.67-2.921 1.437-3.928 2.347-1.054.91-1.915 1.725-2.586 2.443C.335 11.56 0 12.088 0 12.327c0 .24.335.767 1.005 1.533.67.767 1.533 1.58 2.586 2.442 1.006.91 2.347 1.677 3.928 2.347 1.58.719 3.16 1.054 4.741 1.054 1.58 0 3.161-.335 4.742-1.005 1.58-.67 2.92-1.437 3.975-2.347 1.005-.862 1.868-1.677 2.538-2.442.67-.766 1.005-1.293 1.005-1.58 0-.24-.335-.767-1.005-1.534-.67-.766-1.533-1.58-2.538-2.49-1.054-.862-2.395-1.628-3.975-2.3Zm-2.299 8.765c-.67.67-1.484 1.005-2.442 1.005-.958 0-1.772-.335-2.442-1.005-.67-.67-1.006-1.485-1.006-2.443 0-.91.335-1.724 1.006-2.394.67-.67 1.484-1.006 2.442-1.006.958 0 1.772.335 2.442 1.006.67.67 1.006 1.484 1.006 2.394 0 .958-.336 1.772-1.006 2.443Z' />
);

export const viewBox = '0 0 25 25';
